<section class="section-product-hero" *ngIf="coreApiData">
  <div class="section-container">
    <div class="product-hero-content-box">
      <div>
        <span class="product-hero-subheading mar-b-16">{{
          coreApiData?.tags[0]?.fields?.tagText
        }}</span>
        <h1 class="product-hero-header" [innerHTML]="highlightedText"></h1>
        <div
          class="landing-hero-content mar-t-24"
          [innerHtml]="coreApiData.content | toHtml"
        ></div>
        <div class="landing-btn mar-t-48 align-c">
          <a
            #registerLink
            (click)="openRegisterLink($event)"
            href="{{ coreApiData.buttons[0].fields.redirectLink }}"
            target="{{ coreApiData.buttons[0].fields.actionType }}"
            class="btn btn-full"
          >
            {{ coreApiData.buttons[0].fields.buttonText }}
          </a>
          <app-common-talktosales-button
            [text]="coreApiData?.buttons[1]?.fields?.buttonText"
          ></app-common-talktosales-button>
        </div>
      </div>
      <img
        src="{{ coreApiData.image[0].fields.file.url }}"
        alt="{{ coreApiData.image[0].fields.title }}"
      />
    </div>
  </div>
</section>
